/**
 * Index route. The actual routing decision lives in the route's `beforeLoad`
 * guard (see `src/router/index.tsx`) which always redirects elsewhere
 * before this component renders. This is just a safety fallback.
 */
export const HomePage = () => (
  <main className="flex min-h-screen items-center justify-center p-8">
    <p className="text-sm text-muted-foreground">Loading…</p>
  </main>
);
